module.exports = __webpack_public_path__ + "static/media/visitbrussels_1.1b89c249.jpg";